<template>
  <div>
    <el-dialog
      title="消息中心"
      :visible.sync="internalDialogVisible"
      width="1180px"
      custom-class="chat-dialog"
      :before-close="closeDialog"
      @open="initChat"
    >
      <span slot="title" class="dialog-title" style="color: #409EFF; font-weight: bold;">
        消息中心
        <i v-if="isConnecting" class="el-icon-loading connecting-icon"></i>
      </span>
      <div class="chat-container" style="display:flex !important; position:static !important; height:calc(100vh - 450px) !important; width:100% !important; overflow:hidden !important;">
        <!-- 左侧聊天列表 -->
        <div class="chat-sidebar">
          <div class="chat-search">
            <el-input
              v-model="searchQuery"
              placeholder="搜索用户"
              prefix-icon="el-icon-search"
              clearable
              class="blue-search"
              @input="searchUsers"
            ></el-input>
          </div>
          <div class="chat-list">
            <div
              v-for="(chat, index) in chatList"
              :key="`chat-${chat.id || 'unknown'}-${index}`"
              class="chat-item"
              :class="{ active: currentChat && currentChat.id === chat.id }"
              @click="selectChat(chat)"
            >
              <el-avatar
                :size="34"
                :src="chat.avatar || defaultAvatar"
                class="chat-avatar"
                :class="{ 'vip-border': chat.userInfo && chat.userInfo.userLevel > 1 }"
              ></el-avatar>
              <div class="chat-info">
                <div class="chat-name-row">
                  <span class="chat-name">{{ chat.name || chat.sessionName || chat.nickName || chat.userName || '未知用户' }}</span>
                  <span class="chat-time">{{ formatTime(chat.lastTime) }}</span>
                </div>
                <div class="chat-preview-row">
                  <span class="chat-preview">{{ getLastMessage(chat) }}</span>
                  <span v-if="chat.unreadCount && chat.unreadCount > 0" class="unread-count">{{ chat.unreadCount }}</span>
                  <!-- 调试信息：显示未读计数的实际值 -->
                  <span v-if="debugging" style="color: red; font-size: 10px; margin-left: 5px;">[{{ chat.unreadCount || 0 }}]</span>
                </div>
              </div>
            </div>
            <div v-if="chatList.length === 0" class="empty-state">
              <div v-if="!getCookie('token')" class="login-prompt">
                <i class="el-icon-user" style="font-size: 48px; color: #ddd; margin-bottom: 16px;"></i>
                <p style="color: #999; margin: 0;">请先登录后使用聊天功能</p>
              </div>
              <div v-else>
                暂无聊天记录
              </div>
            </div>
          </div>
        </div>
        
        <!-- 右侧聊天内容 -->
        <div class="chat-content">
          <template v-if="currentChat">
            <div class="chat-header">
              <div class="chat-title">{{ currentChat.name || currentChat.sessionName || currentChat.nickName || currentChat.userName || '未知用户' }}</div>
            </div>
            <div class="message-area" ref="messageArea">
              <ul id="msgList" class="msg-list">
                <div class="chat-load-more" v-show="hasMore" @click="loadMore" v-loading="loadingMore">
                  <span style="color: #1C1B19">加载更多</span>
                </div>
                
                <el-row class="msg-item" v-for="(item, index) in messages" :key="item.id || index">
                  <!-- 对方发送的消息 -->
                  <div v-if="!item.isSelf && item.content" class="other-message">
                    <div class="msg-avatar">
                      <span class="pointer" :class="item.userTag > 0 ? 'vip-avatar' : ''">
                        <el-avatar
                          :class="item.userTag > 0 ? 'vip-color' : ''"
                          :src="item.avatar"
                          fit="fill"
                          size="large">
                        </el-avatar>
                        <span style="font-size: 10px; right: -4px; bottom: -1px;" class="vip-text pointer"
                              v-if="item.userTag > 0"
                              :data-vip="getUserTag(item.userTag) ? getUserTag(item.userTag).dictLabel : item.userTag">V</span>
                      </span>
                    </div>
                    <div class="msg-info">
                      <p class="msg-header">
                        <span class="msg-debug" v-if="debugging" style="color: #999; font-size: 10px;">[其他:{{ index }}]</span>
                        <span class="send-user pointer">{{ item.nickname }}</span>
                        <el-tag size="mini" effect="plain" style="margin-left:5px;"
                               v-if="getUserTag(item.userTag)"
                               :type="getUserTag(item.userTag).listClass">V
                        </el-tag>
                        <span class="timeAgo">
                          <span class="lv" style="background-color: rgba(255, 255, 255, 0.9);"
                                :class="'lv'+ item.userLevel" v-if="getUserLevel(item.userLevel)">
                            {{ getUserLevel(item.userLevel) }}
                          </span>
                        </span>

                        <span class="iconfont" v-if="item.gender=='1'"
                              style="margin-left: 5px; color: dodgerblue; font-size: 18px; font-weight: bold;">&#xe641;</span>
                        <span class="iconfont" v-if="item.gender=='2'"
                              style="margin-left: 5px; color: palevioletred; font-size: 18px; font-weight: bold;">&#xe643;</span>

                        <span class="send-time" v-if="item.userIpPossession">IP属地:{{ item.userIpPossession }}</span>

                        <span class="send-time">{{ formatTime(item.createTime) }}</span>
                      </p>

                      <div class="msg-left-content-container">
                        <p v-if="!item.category || item.category == 20001" class="msg-content" v-html="item.content"></p>
                        <audio v-else-if="item.category == 20002" :src="item.content" controls="controls">
                          你的浏览器不支持
                        </audio>
                        <div v-else-if="item.category == 20003">
                          <img :src="item.content" class="chat-msg-img" @click="previewImage(item.content)">
                        </div>
                        <div v-else-if="item.category == 20004">
                          <span><i class="el-icon-video-camera"></i> 视频通话</span>
                        </div>
                        <div v-else-if="item.category == 20005">
                          <span><i class="el-icon-phone"></i> 语音通话</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- 自己发送的消息 -->
                  <el-row v-else-if="item.isSelf && item.content" style="text-align: right" class="self-message">
                    <div style="float: right" class="msg-avatar">
                      <span class="pointer" :class="item.userTag > 0 ? 'vip-avatar' : ''">
                        <el-avatar :class="item.userTag > 0 ? 'vip-color' : ''" 
                                   :src="item.avatar"
                                   fit="fill" size="large"></el-avatar>
                        <span style="font-size: 10px; right: -4px; bottom: -1px;" class="vip-text pointer"
                              v-if="item.userTag > 0"
                              :data-vip="getUserTag(item.userTag) ? getUserTag(item.userTag).dictLabel : item.userTag">V</span>
                      </span>
                    </div>
                    <div style="float: right" class="msg-info">
                      <p class="msg-header">
                        <span class="msg-debug" v-if="debugging" style="color: #999; font-size: 10px;">[自己:{{ index }}]</span>
                        <span class="send-time">{{ formatTime(item.createTime) }}</span>

                        <span class="send-time" v-if="item.userIpPossession">IP属地:{{ item.userIpPossession }}</span>

                        <el-tag size="mini" effect="plain" style="margin-left:5px;"
                               v-if="getUserTag(item.userTag)"
                               :type="getUserTag(item.userTag).listClass">V
                        </el-tag>

                        <span class="timeAgo">
                          <span class="lv" style="background-color: rgba(255, 255, 255, 0.9);"
                                :class="'lv'+ item.userLevel" v-if="getUserLevel(item.userLevel)">
                            {{ getUserLevel(item.userLevel) }}
                          </span>
                        </span>

                        <span class="iconfont" v-if="item.gender=='1'"
                              style="color: dodgerblue; font-size: 18px; font-weight: bold;">&#xe641;</span>
                        <span class="iconfont" v-if="item.gender=='2'"
                              style="color: palevioletred; font-size: 18px; font-weight: bold;">&#xe643;</span>
                        <span class="send-user pointer">{{ item.nickname }}</span>
                      </p>

                      <div class="msg-right-content-container">
                        <p v-if="!item.category || item.category == 20001" class="msg-content" v-html="item.content"></p>
                        <audio v-else-if="item.category == 20002" :src="item.content" controls="controls">
                          你的浏览器不支持
                        </audio>
                        <div v-else-if="item.category == 20003">
                          <img :src="item.content" class="chat-msg-img" @click="previewImage(item.content)">
                        </div>
                        <div v-else-if="item.category == 20004">
                          <span><i class="el-icon-video-camera"></i> 视频通话</span>
                        </div>
                        <div v-else-if="item.category == 20005">
                          <span><i class="el-icon-phone"></i> 语音通话</span>
                        </div>
                      </div>
                    </div>
                  </el-row>
                </el-row>
              </ul>
            </div>
            <div class="input-area">
              <div class="toolbar">
                <div class="emoji-wrapper" ref="emojiWrapper">
                  <i class="el-icon-picture-outline" @click="toggleEmojiPanel" title="表情"></i>
                  
                  <!-- 表情面板 -->
                  <div v-if="showEmojiPanel" class="emoji-panel">
                    <ul class="emoji-list">
                      <li v-for="(emoji, index) in emojiList" :key="index" class="emoji-item" @click="insertEmoji(emoji)">
                        <img :src="'/static/images/emoji/' + emoji" alt="表情" width="24" height="24">
                      </li>
                    </ul>
                  </div>
                </div>
                <!-- <i class="el-icon-picture" @click="openImageUpload" title="图片"></i>
                <i class="el-icon-video-camera" @click="openVideoCall" title="视频通话"></i>
                <i class="el-icon-phone" @click="openAudioCall" title="音频通话"></i> -->
              </div>
              <div class="message-input">
                <el-input
                  type="textarea"
                  :rows="3"
                  v-model="inputMessage"
                  placeholder="输入消息..."
                  @keyup.enter.native="sendMessage"
                  ref="messageInput"
                ></el-input>
              </div>
              <div class="send-button">
                <el-button type="primary" @click="sendMessage">发送</el-button>
              </div>
            </div>
          </template>
          <div class="no-chat-selected" v-else>
            <i class="el-icon-chat-round"></i>
            <p>请选择一个聊天</p>
          </div>
        </div>
      </div>
    </el-dialog>
    
    <!-- 图片预览 -->
    <el-image-viewer
      v-if="showImageViewer"
      :on-close="closeImageViewer"
      :url-list="[previewImageUrl]"
    />
  </div>
</template>

<script>
import { getCookie } from "@/utils/cookieUtils";
import { roomList, history } from "@/api/chat";
import { getUserList, getUserByUid } from "@/api/about";
import { getListByDictType } from "@/api/sysDictData";
import { readUserReceiveNoticeCount } from "@/api/notice";
import webSocketManager from "@/utils/WebSocketManager";

export default {
  name: "chat-popup",
  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    userUid: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      // 内部弹窗状态管理
      internalDialogVisible: false,
      
      // 基础数据
      defaultAvatar: process.env.defaultAvatar ,
      searchQuery: "",
      currentUserAvatarUrl: null,
      debugging: false, // 调试模式开关，用于显示未读计数调试信息
      
      // 图片预览
      showImageViewer: false,
      previewImageUrl: '',
      
      // 表情面板
      showEmojiPanel: false,
      emojiList: [],
      
      // 聊天列表
      chatList: [],
      currentChat: null,
      
      // 消息相关
      messages: [],
      inputMessage: "",
      

      
      // 用户标签和等级字典
      userTagDictList: [],
      userLevelDictList: [],
      
      // 更多聊天相关
      currentPage: 1,
      pageSize: 20,
      hasMore: true,
      loadingMore: false,
      
      // 表情相关
      showEmojiPanel: false,
      emojiList: [
        '1000.png', '1004.png', '1005.png', '1006.png', '1007.png',
        '1008.png', '1009.png', '1010.png', '1011.png', '1012.png',
        '1013.png', '1014.png', '1015.png', '1016.png', '1017.png',
        '1018.png', '1019.png', '1020.png', '1021.png', '1022.png',
        '2000.gif', '2001.gif', '2002.gif', '2003.gif', '2004.gif'
      ],
      
      // WebSocket连接状态
      isConnecting: false,
      
      // 消息去重
      processedMessages: new Set(), // 用于防止重复处理消息
      

    };
  },
  computed: {
    // 用于获取指定消息的用户标签
    getMessageTags() {
      return function(msg) {
        if (!msg.userTag || !this.userTagDictList.length) return [];
        return this.userTagDictList.filter(tag => 
          msg.userTag && msg.userTag.indexOf(tag.dictValue) > -1
        );
      }
    },
    
    // 计算聊天消息总未读数
    totalChatUnreadCount() {
      if (!this.chatList || this.chatList.length === 0) {
        return 0;
      }
      return this.chatList.reduce((total, chat) => {
        return total + (chat.unreadCount || 0);
      }, 0);
    }

  },
  watch: {
    dialogVisible: {
      immediate: true,
      handler(newVal) {
        this.internalDialogVisible = newVal;
      }
    },
    internalDialogVisible(newVal) {
      // 同步状态到父组件
      this.$emit('update:dialogVisible', newVal);
      
      if (newVal) {
        // 弹窗显示时，立即强制刷新用户头像
        this.forceRefreshAvatar();
        
        // 延迟初始化，确保DOM已完全渲染
        setTimeout(() => {
          this.initChat();
        }, 500);
      } else {
        this.cleanupChat();
      }
    },
    searchQuery(val) {
      if (val) {
        this.searchUsers();
      } else {
        this.loadChatList();
      }
    },

    userUid(newVal) {
      if (newVal && this.internalDialogVisible) {
        this.initTargetChat(newVal);
      }
    }
  },
  created() {
    // 获取表情包列表
    this.getDictList();
    
    // 尝试获取当前用户头像
    this.storeCurrentUserAvatar();
    
    // 注册WebSocket消息处理器
    this.registerWebSocketHandlers();
  },
  beforeDestroy() {
    // 移除WebSocket消息处理器
    this.unregisterWebSocketHandlers();
    
    // 移除点击事件监听器
    document.removeEventListener('click', this.handleClickOutside);
  },
  mounted() {
    // 添加点击事件监听器，点击表情面板外部时关闭表情面板
    document.addEventListener('click', this.handleClickOutside);
    
    // 尝试获取当前用户头像（如果created中没有成功获取）
    if (!this.currentUserAvatarUrl) {
      this.storeCurrentUserAvatar();
    }
    
    // 注意：initChat在dialogVisible的watch中处理，避免重复初始化
  },
  methods: {
    // 获取Cookie方法，供模板使用
    getCookie(name) {
      return getCookie(name);
    },
    
    // 统一的头像获取方法
    getValidAvatar(avatarUrl) {
      if (!avatarUrl || 
          avatarUrl.includes('defaultAvatar.png') || 
          avatarUrl.includes('favicon.png') ||
          avatarUrl.includes('default.png') ||
          avatarUrl.includes('cube.elemecdn.com')) {
        return this.defaultAvatar;
      }
      return avatarUrl;
    },
    
    /**
     * 获取字典列表
     */
    getDictList() {
      // 为每个字典类型单独发送请求，避免格式问题
      getListByDictType({
        dictType: 'sys_user_tag'
      }).then(response => {
        if (response.data) {
          this.userTagDictList = response.data;
        }
      }).catch(error => {
        console.error("获取用户标签字典失败", error);
      });
      
      getListByDictType({
        dictType: 'sys_user_level'
      }).then(response => {
        if (response.data) {
          this.userLevelDictList = response.data;
        }
      }).catch(error => {
        console.error("获取用户等级字典失败", error);
      });
    },
    
    // 初始化与指定用户的聊天
    async initTargetChat(targetUid) {

      if (!targetUid) return;
      
      try {
        // 检查是否已存在该用户的聊天
        let existingChat = this.chatList.find(chat => chat.receiveId === targetUid);
        
        if (!existingChat) {
          // 默认信息
          let engineerName = '工程师';
          let engineerAvatar = this.defaultAvatar;
          
          try {
            // 使用API获取用户信息
            const response = await getUserByUid({
              userUid: targetUid,
              refresh:false
            });
            
            if (response && response.data && response.data.nickName) {
              engineerName = response.data.nickName;
              engineerAvatar = response.data.photoUrl || this.defaultAvatar;
            }
          } catch (apiError) {
            console.warn("获取用户信息失败，使用默认信息:", apiError);
            
            // API失败时的备用方案：尝试从父组件获取信息
            if (this.$parent && this.$parent.engineerData) {
              engineerName = this.$parent.engineerData.nickName || this.$parent.engineerData.name || '工程师';
              engineerAvatar = this.$parent.engineerData.photoUrl || this.$parent.engineerData.avatar || this.defaultAvatar;
            }
          }
          
          // 创建新的聊天会话
          existingChat = {
            id: 'user_' + targetUid,
            name: engineerName,
            avatar: engineerAvatar,
            receiveId: targetUid,
            lastMessage: '',
            lastTime: new Date(),
            unreadCount: 0,
            userInfo: {
              uid: targetUid,
              nickName: engineerName
            }
          };
          
          // 添加到聊天列表顶部
          this.chatList.unshift(existingChat);
        }
        
        // 选择这个聊天
        this.selectChat(existingChat);
      } catch (error) {
        console.error("初始化目标聊天时发生错误:", error);
        this.$message.error("无法初始化与该用户的聊天");
      }
    },
    
    // 初始化聊天
    initChat() {
      
      try {
        // 验证用户是否已登录
        const token = getCookie("token");
        if (!token) {
          // 显示登录提示而不是错误信息
        this.chatList = [];
        this.currentChat = null;
        // 用户未登录时，保留临时消息以便登录后继续使用
        this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
        // 重新初始化processedMessages，但不清理，避免影响临时消息逻辑
        if (!this.processedMessages) {
          this.processedMessages = new Set();
        }
          // 显示友好的登录提示
          this.$nextTick(() => {
            this.$message({
              message: '请先登录后再使用聊天功能',
              type: 'warning',
              duration: 3000
            });
          });
          return;
        }
        
        // 设置连接状态为正在连接
        this.isConnecting = true;
        
        // 重新初始化processedMessages，但不清理，避免影响临时消息逻辑
        if (!this.processedMessages) {
          this.processedMessages = new Set();
        }
        
        // 确保获取了用户头像 - 每次初始化都强制刷新
        this.forceRefreshAvatar();
        
        // WebSocket连接现在由全局统一管理，检查连接状态
        if (webSocketManager.isConnected()) {
          // WebSocket已连接
          this.isConnecting = false;
        } else {
          // WebSocket未连接，调用全局初始化
          this.$initGlobalWebSocket();
          this.isConnecting = false;
        }
        
        // 加载聊天列表
        this.loadChatList();
        
        // 如果指定了用户，则直接打开与该用户的聊天
        if (this.userUid) {
          // 延迟执行，确保聊天列表已加载
          this.$nextTick(() => {
            this.initTargetChat(this.userUid);
          });
        }
      } catch (error) {
        console.error("初始化聊天时发生错误:", error);
        this.$message.error("初始化聊天失败，请重试");
        this.isConnecting = false;
        // 不要关闭弹窗
      }
    },
    
    /**
     * 强制刷新用户头像
     * 从store统一获取，不再依赖DOM查询
     */
    forceRefreshAvatar() {
      this.currentUserAvatarUrl = this.getCurrentUserAvatar();
    },
    
    /**
     * 获取当前用户头像（统一入口）
     * 优先从store获取，fallback到默认头像
     */
    getCurrentUserAvatar() {
      // 优先使用store的getter（已含有效性校验）
      const storePhoto = this.$store.getters.getUserPhoto;
      if (storePhoto && storePhoto !== 'https://file.itgetjob.com:15090/rootfile/1742378549034.png') {
        return storePhoto;
      }
      // 其次从userInfo直接取
      const userInfo = this.$store.state.user.userInfo || {};
      if (userInfo.photoUrl && 
          !userInfo.photoUrl.includes('defaultAvatar.png') && 
          !userInfo.photoUrl.includes('favicon.png')) {
        return userInfo.photoUrl;
      }
      return this.defaultAvatar;
    },
    
    /**
     * 清理聊天相关资源
     */
    cleanupChat() {
      
      // 设置强制关闭标记
      this.forceClosed = true;
      
      // 关闭所有WebSocket连接
      this.closeAllSocketConnections();
      
      // 重置数据，避免弹窗重新打开时显示旧数据
      this.currentChat = null;
      // 保留临时消息，只清除历史消息
      this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
    },
    
    /**
     * 存储当前用户头像URL
     * 统一从store获取，不再依赖DOM查询
     */
    storeCurrentUserAvatar() {
      this.currentUserAvatarUrl = this.getCurrentUserAvatar();
    },
    
    // 加载聊天列表
    loadChatList() {
      roomList().then(response => {
        if (response.data) {
          // 确保数据结构兼容性
          this.chatList = response.data.map(room => {
            // 检查未读计数是否异常（超过合理范围）
            let unreadCount = room.unreadCount || room.unread || 0;
            
            // 如果未读计数超过20，可能是服务器端数据异常，重置为0
            if (unreadCount > 20) {
              console.warn('检测到异常未读计数:', room.sessionName || room.title, '未读数:', unreadCount, '已重置为0');
              unreadCount = 0;
            }
            
            return {
              id: room.sessionId || room.uid,
              name: room.sessionName || room.title || '聊天',
              avatar: room.avatar || this.defaultAvatar,
              receiveId: room.receiveId === this.$store.state.user.uid ? room.belongUserId : room.receiveId,
              lastMessage: room.lastContent || room.subtitle || '',
              lastTime: room.lastTime ? new Date(room.lastTime) : (room.time ? new Date(room.time) : new Date()),
              unreadCount: unreadCount,
              // 保存原始房间信息
              roomInfo: room
            };
          });
          
          // 初始加载时通知未读数变化，确保父组件获得正确的计数
          this.$nextTick(() => {
            this.notifyUnreadCountChange();
          });
          // 聊天列表更新完成
          
        }
      }).catch(error => {
        console.error("加载聊天列表失败:", error);
      });
    },
    
    // 获取最后一条消息预览
    getLastMessage(chat) {
      if (!chat.lastMessage && !chat.lastContent) {
        return '点击开始聊天';
      }
      
      const content = chat.lastMessage || chat.lastContent;
      return this.formatChatPreview(content);
    },
    
    // 格式化聊天预览
    formatChatPreview(message) {
      if (!message) return '点击开始聊天';
      
      // 如果消息包含表情图片，显示[表情]
      if (message.includes('<img') && message.includes('emoji')) {
        return '[表情]';
      }
      
      // 尝试解析JSON格式
      try {
        const msgObj = typeof message === 'string' ? JSON.parse(message) : message;
        if (msgObj.category) {
          // 根据消息类型返回不同的预览
          switch (msgObj.category) {
            case 20001: // 文本
              return msgObj.content.length > 20 ? 
                msgObj.content.substring(0, 20) + '...' : 
                msgObj.content;
            case 20002:
              return '[语音]';
            case 20003:
              return '[图片]';
            case 20004:
              return '[视频通话]';
            case 20005:
              return '[语音通话]';
            default:
              return msgObj.content || '新消息';
          }
        } else {
          // 移除HTML标签，只显示纯文本
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = message;
          const textContent = tempDiv.textContent || tempDiv.innerText || '';
          return textContent.length > 20 ? textContent.substring(0, 20) + '...' : textContent;
        }
      } catch (e) {
        // 如果不是JSON，尝试移除HTML标签
        if (typeof message === 'string' && message.includes('<')) {
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = message;
          const textContent = tempDiv.textContent || tempDiv.innerText || '';
          return textContent.length > 20 ? textContent.substring(0, 20) + '...' : textContent;
        }
        
        // 直接显示文本
        const text = typeof message === 'string' ? message : JSON.stringify(message);
        return text.length > 20 ? text.substring(0, 20) + '...' : text;
      }
    },
    
    // 搜索用户
    searchUsers() {
      if (!this.searchQuery.trim()) {
        this.loadChatList();
        return;
      }
      
      
      getUserList({
        keyword: this.searchQuery,
        currentPage: 1,
        pageSize: 10
      }).then(response => {
        if (response.code == this.$ECode.SUCCESS && response.data && response.data.records) {
          // 转换结果格式
          this.chatList = response.data.records.map(user => ({
            id: 'user_' + user.uid,
            name: user.nickName || user.userName || '未知用户',
            avatar: user.photoUrl || user.avatar || this.defaultAvatar,
            receiveId: user.uid,
            lastMessage: '点击开始聊天',
            lastTime: user.createTime ? new Date(user.createTime) : new Date(),
            unreadCount: 0,
            // 保存原始用户信息
            userInfo: user
          }));
          
          // 搜索用户列表更新完成
          
        } else {
          this.chatList = [];
          console.warn("搜索结果为空或格式不符合预期");
        }
      }).catch(error => {
        console.error("搜索用户失败:", error);
        this.$message.error("搜索用户失败");
        this.chatList = [];
      });
    },
    
    // 选择聊天
    selectChat(chat) {
      
      // 判断是用户搜索结果还是聊天会话
      const isSearchUser = chat.id.startsWith('user_');
      
      if (isSearchUser) {
        // 处理选择搜索到的用户
        
        // 首先从常规聊天列表加载，确保有最新数据
        roomList().then(response => {
          if (response.data) {
            // 将API返回的聊天会话转换为标准格式
            const normalizedChats = response.data.map(room => ({
              id: room.sessionId || room.uid,
              name: room.sessionName || room.title || '聊天',
              avatar: room.avatar || this.defaultAvatar,
              receiveId: room.receiveId === this.$store.state.user.uid ? room.belongUserId : room.receiveId,
              lastMessage: room.lastContent || room.subtitle || '',
              lastTime: room.lastTime ? new Date(room.lastTime) : (room.time ? new Date(room.time) : new Date()),
              unreadCount: room.unreadCount || room.unread || 0,
              roomInfo: room
            }));
            
            // 查找是否已经有与该用户的聊天
            const existingChat = normalizedChats.find(item => 
              item.receiveId === chat.receiveId
            );
            
            if (existingChat) {
              this.currentChat = existingChat;
              this.messages = []; // 清空当前消息
              // 清空搜索
              this.searchQuery = "";
              this.chatList = normalizedChats;
              this.loadMessages(existingChat);
            } else {
              // 清空搜索
              this.searchQuery = "";
              this.chatList = normalizedChats;
              
              // 创建临时聊天对象
              const tempChat = {
                id: '', // 不设置ID，让后端自动生成
                receiveId: chat.receiveId,
                name: chat.name,
                avatar: chat.avatar,
                lastMessage: '',
                lastTime: new Date(),
                unreadCount: 0,
                isNewChat: true
              };
              
              this.currentChat = tempChat;
              // 保留临时消息，只清除非临时消息
              this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
              this.loadMessages(tempChat);
            }
          }
        }).catch(error => {
          console.error("加载聊天列表失败:", error);
          // 出错时仍然尝试加载聊天
          const tempChat = {
            id: '',
            receiveId: chat.receiveId,
            name: chat.name,
            avatar: chat.avatar,
            lastMessage: '',
            lastTime: new Date(),
            unreadCount: 0,
            isNewChat: true
          };
          
          this.currentChat = tempChat;
          // 保留临时消息，只清除非临时消息
          this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
          this.loadMessages(tempChat);
        });
      } else {
        // 普通聊天会话
        this.currentChat = chat;
        // 保留临时消息，只清除非临时消息
        this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
        this.loadMessages(chat);
      }
      
      // 标记已读 - 使用数组赋值方式确保响应式更新
      const chatIndex = this.chatList.findIndex(item => item.id === chat.id);
      if (chatIndex !== -1) {
        // 只有当未读计数大于0时才进行更新和通知
        const currentUnreadCount = this.chatList[chatIndex].unreadCount || 0;
        if (currentUnreadCount > 0) {
          // 创建新的chatList数组
          const newChatList = [...this.chatList];
          newChatList[chatIndex] = {
            ...this.chatList[chatIndex],
            unreadCount: 0
          };
          // 使用数组赋值方式确保响应式更新（与其他方法保持一致）
          this.chatList = newChatList;
          
          // 调用后端API标记消息为已读状态
          readUserReceiveNoticeCount({
            type: 'message' // 标记消息类型为已读
          }).then(response => {
            if (response.code === this.$ECode.SUCCESS) {
              // 通知父组件聊天未读数变化（仅在未读数实际变化时触发）
              this.notifyUnreadCountChange();
            } else {
              console.error('ChatPopup: 后端消息已读状态更新失败:', response.message);
              // 即使API调用失败，也要通知前端更新，避免界面不一致
              this.notifyUnreadCountChange();
            }
          }).catch(error => {
            console.error('ChatPopup: 调用标记已读API失败:', error);
            // 即使API调用失败，也要通知前端更新，避免界面不一致
            this.notifyUnreadCountChange();
          });
        }
      }
    },
    
    // 加载消息历史
    loadMessages(chatObj) {
      // 清理临时消息相关状态
      if (this.processedMessages) {
        this.processedMessages.clear();
      }
      
      // 使用传入的聊天对象或当前聊天对象
      const chat = chatObj || this.currentChat;
      if (!chat) return;
      
      // 检查是否需要刷新聊天列表
      const needRefreshList = !chatObj && chat.isNewChat;
      
      
      // 构建请求参数
      const params = {};
      
      if (chat.id && !chat.isNewChat) {
        // 如果有聊天ID且不是新聊天，使用聊天ID查询
        params.roomId = chat.id;
      } else if (chat.receiveId) {
        // 否则使用接收者ID查询
        params.toUserId = chat.receiveId;
        // 重要：对于新聊天，必须设置roomId=0，否则后端会报错
        params.roomId = chat.id || 0;
      }
      
      params.page = 1;
      params.pageSize = 20;
      
      
      history(params).then(response => {
        
        // 检查响应结构
        let records = [];
        if (response.data && response.data.records) {
          records = response.data.records;
        } else if (Array.isArray(response.data)) {
          records = response.data;
        }
        
        // 重置当前页码
        this.currentPage = 1;
        
        if (records.length > 0) {
          // 如果新建的聊天返回了房间ID，更新当前聊天信息
          if (response.data && response.data.sessionId && 
             (chat.isNewChat || !chat.id)) {
            if (this.currentChat && this.currentChat.receiveId === chat.receiveId) {
              this.currentChat.id = response.data.sessionId;
              this.currentChat.isNewChat = false;
              
              // 如果需要刷新聊天列表，则刷新
              if (needRefreshList) {
                this.loadChatList();
              }
            }
          }
          
          // 获取当前用户信息，用于判断消息是否为自己发送
          const currentUserInfo = this.$store.state.user.userInfo || {};
          const currentUserUid = currentUserInfo.uid;
          const currentUserNickname = currentUserInfo.nickname;
          
          
          const processedMessages = records.map(msg => {
            
            // 判断消息是否为空
            if (!msg.message && !msg.content) {
              return null;
            }
            
            const content = msg.message || msg.content || '';
            if (!content || content.trim() === '') {
              return null;
            }
            
            const fromUserId = msg.fromUserId || msg.senderId || '';
            const fromNickname = msg.fromUserNickName || msg.nickname || '';
            
            // 判断消息是否是自己发送的
            // 增强判断逻辑，确保正确识别自己发送的消息
            const isSelf = 
              (currentUserUid && fromUserId && fromUserId === currentUserUid) || 
              (currentUserNickname && fromNickname && fromNickname === currentUserNickname) ||
              (chat && chat.receiveId && msg.toUserId && msg.toUserId === chat.receiveId) ||  
              (fromNickname === '我' || (this.$store.state.user.userInfo && fromNickname === this.$store.state.user.userInfo.userName));
            
            
            // 使用与handleChatMessage相同的逻辑获取用户信息
            const userNickname = isSelf ? (currentUserInfo.nickName || currentUserInfo.nickname || currentUserInfo.userName || fromNickname || '我') : (fromNickname || msg.fromUserNickName || '未知用户');
            
            // 统一的头像获取逻辑
            let userAvatar;
            if (isSelf) {
              userAvatar = this.getCurrentUserAvatar();
            } else {
              // 对于其他用户，优先从聊天对象获取，其次从消息体获取
              userAvatar = this.getValidAvatar(chat && chat.avatar) !== this.defaultAvatar ? chat.avatar :
                           this.getValidAvatar(msg.fromUserAvatar) !== this.defaultAvatar ? msg.fromUserAvatar :
                           this.defaultAvatar;
            }
            
            
            return {
              id: msg.uid,
              content: content,
              message: content,
              category: msg.category || 20001,
              createTime: msg.createTime || msg.sendTime || Date.now(),
              sendTime: msg.sendTime || msg.createTime || Date.now(),
              avatar: userAvatar,
              nickname: userNickname,
              fromUserNickName: userNickname,
              userTag: msg.userTag || 0,
              userLevel: msg.userLevel || 1,
              gender: msg.gender || '1',
              userIpPossession: msg.userIpPossession || '',
              fromUserId: fromUserId,
              isSelf: isSelf  // 确保isSelf字段正确设置
            };
          }).filter(msg => msg !== null);
          
          // 只有当聊天对象与当前选中的聊天对象匹配时，才更新消息列表
          if (!chatObj || (this.currentChat && this.currentChat.receiveId === chat.receiveId)) {
            // 保留现有的临时消息，合并新加载的消息
            const tempMessages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
            this.messages = [...tempMessages, ...processedMessages];
            
            // 按时间顺序排序消息
            this.messages.sort((a, b) => new Date(a.createTime) - new Date(b.createTime));
            
            
            // 滚动到底部
            this.$nextTick(() => {
              this.scrollToBottom();
            });
          }
          
          // 检查是否还有更多历史记录
          this.hasMore = records.length >= this.pageSize;
        } else {
          console.warn("聊天记录为空或返回格式不符合预期", response.data);
          // 只有当聊天对象与当前选中的聊天对象匹配时，才更新消息列表
          if (!chatObj || (this.currentChat && this.currentChat.receiveId === chat.receiveId)) {
            // 保留临时消息，只清除非临时消息
            this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
            this.hasMore = false;
          }
        }
      }).catch(error => {
        console.error("加载历史消息失败:", error);
        // 只有当聊天对象与当前选中的聊天对象匹配时，才更新消息列表
        if (!chatObj || (this.currentChat && this.currentChat.receiveId === chat.receiveId)) {
          // 保留临时消息，只清除非临时消息
          this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
          this.hasMore = false;
        }
      });
    },
    
    // 处理消息格式
    formatMessageContent(content, category) {
      if (!content) return '';
      
      // 根据消息类型处理内容
      switch (category) {
        case 20001: // 文本消息
          // 检查内容是否已经包含HTML标记
          if (content.includes('<') && content.includes('>')) {
            // 过滤掉script标签，防止XSS攻击
            return content.replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '');
          }
          return this.escapeHtml(content);
        case 20002: // 语音消息
          return '[语音消息]';
        case 20003: // 图片消息
          return '[图片消息]';
        case 20004: // 视频通话
          return '[视频通话]';
        case 20005: // 语音通话
          return '[语音通话]';
        default:
          if (typeof content === 'object') {
            try {
              return JSON.stringify(content);
            } catch (e) {
              return String(content);
            }
          }
          return this.escapeHtml(content);
      }
    },
    
    // 简单的HTML转义函数
    escapeHtml(text) {
      if (!text) return '';
      return text
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    
    // 滚动到底部
    scrollToBottom() {
      this.$nextTick(() => {
        const messageArea = this.$refs.messageArea;
        if (messageArea) {
          const msgList = messageArea.querySelector('.msg-list');
          if (msgList) {
            // 使用scrollHeight确保滚动到最底部
            msgList.scrollTop = msgList.scrollHeight + 500;
          }
        }
      });
      
      // 添加额外的延迟滚动，确保DOM完全更新后再滚动
      setTimeout(() => {
        const messageArea = this.$refs.messageArea;
        if (messageArea) {
          const msgList = messageArea.querySelector('.msg-list');
          if (msgList) {
            msgList.scrollTop = msgList.scrollHeight + 500;
          }
        }
      }, 100);
    },
    
    // 初始化WebSocket连接和消息处理器
    initWebSocket() {
      // 确保WebSocket连接
      webSocketManager.connect().then(() => {

        this.registerWebSocketHandlers();
      }).catch(error => {

        // 即使连接失败也要注册处理器，以便重连后能正常工作
        this.registerWebSocketHandlers();
      });
    },
    
    // 注册WebSocket消息处理器
    registerWebSocketHandlers() {
      // 先移除可能存在的旧处理器，避免重复注册
      this.unregisterWebSocketHandlers();
      
      // 为每个ChatPopup实例生成唯一的处理器ID
      this.handlerId = `chatPopup_${this._uid}_${Date.now()}`;
      
      // 注册通用消息处理器，监听所有消息
      webSocketManager.onMessage('*', this.handleDomainEvent, this.handlerId);
      
      // 保存连接状态监听器引用，以便后续移除
      this.connectionListener = (status) => {
        this.isConnecting = status !== 'connected';
        // WebSocket连接状态变化
      };
      
      // 注册连接状态监听器
      webSocketManager.onConnectionChange(this.connectionListener);
      
      // WebSocket消息处理器已注册
    },
    
    // 移除WebSocket消息处理器
    unregisterWebSocketHandlers() {
      try {
        if (this.handlerId) {
          webSocketManager.offMessage('*', this.handlerId);
          this.handlerId = null;
        }
        if (this.connectionListener) {
          webSocketManager.offConnectionChange(this.connectionListener);
          this.connectionListener = null;
        }
        // WebSocket消息处理器已移除
      } catch (error) {
        // 移除WebSocket处理器时出错
      }
    },
    
    // 处理WebSocket域事件
    handleDomainEvent(message) {

      
      // 只处理聊天相关的消息，避免与其他组件冲突
      if (message.category !== 20001) {
        // 不是聊天消息，忽略处理
        return;
      }
      
      // 根据消息类型处理
      switch (message.messageType) {
        case 10001: // 普通消息
          // 只处理消息，不重复刷新列表，避免双重计数
          this.handleChatMessage(message);
          break;
        case 10002: // 系统通知
          this.$message.info(message.message);
          break;
        case 10010: // 新聊天通知
          // 仅用于刷新会话，不在消息区展示，避免重复两条同内容消息
          this.refreshRoomList(message);
          break;
        case 10011: // 撤回消息
          this.refreshRoomListWithdraw(message);
          break;
        default:
          // 收到未知类型消息
      }
    },
      

    
    // 刷新聊天列表（参照ChatRoom组件的实现）
    refreshRoomList(messageVo) {
      
      // 记录当前的聊天，用于比较
      const currentChatId = this.currentChat ? this.currentChat.id : null;
      const currentReceiveId = this.currentChat ? this.currentChat.receiveId : null;
      
      // 加载最新的聊天列表
      roomList().then(response => {
        if (response.data) {
          this.chatList = response.data.map(room => ({
            id: room.sessionId || room.uid,
            name: room.sessionName || room.title || '聊天',
            avatar: room.avatar || this.defaultAvatar,
            receiveId: room.receiveId === this.$store.state.user.uid ? room.belongUserId : room.receiveId,
            lastMessage: room.lastContent || room.subtitle || '',
            lastTime: room.lastTime ? new Date(room.lastTime) : (room.time ? new Date(room.time) : new Date()),
            unreadCount: room.unreadCount || room.unread || 0,
            // 保存原始房间信息
            roomInfo: room,
            // 保存其他可能需要的属性
            sessionId: room.sessionId,
            uid: room.uid
          }));
          
          // 刷新聊天列表时通知未读数变化
          this.$nextTick(() => {
            this.notifyUnreadCountChange();
          });
          
          
          // 检查是否有新的聊天需要选择
          // 查找与消息相关的聊天室
          const relatedChat = this.chatList.find(chat => 
            chat.id === messageVo.roomId || 
            chat.receiveId === messageVo.toUserId || 
            chat.receiveId === messageVo.fromUserId
          );
          
          if (relatedChat) {
            
            // 如果当前正在聊天且匹配这个新聊天，更新当前聊天信息
            if (currentChatId && (
                currentChatId === relatedChat.id || 
                currentReceiveId === relatedChat.receiveId || 
                currentReceiveId === messageVo.toUserId || 
                currentReceiveId === messageVo.fromUserId
              )) {
              this.currentChat = relatedChat;
              
              // 标记为已读 - 使用数组赋值方式确保响应式更新
              const chatIndex = this.chatList.findIndex(item => item.id === relatedChat.id);
              if (chatIndex !== -1) {
                // 创建新的chatList数组
                const newChatList = [...this.chatList];
                newChatList[chatIndex] = {
                  ...newChatList[chatIndex],
                  unreadCount: 0
                };
                // 使用数组赋值方式确保响应式更新（与其他方法保持一致）
                this.chatList = newChatList;
                
                // 聊天已标记为已读
              }
            }
          }
        }
      }).catch(error => {
        console.error("刷新聊天列表失败:", error);
      });
    },
    
    // 处理消息撤回（参照ChatRoom组件的实现）
    refreshRoomListWithdraw(messageVo) {
      
      // 记录当前的聊天，用于比较
      const currentChatId = this.currentChat ? this.currentChat.id : null;
      
      // 加载最新的聊天列表
      roomList().then(response => {
        if (response.data) {
          this.chatList = response.data.map(room => ({
            id: room.sessionId || room.uid,
            name: room.sessionName || room.title || '聊天',
            avatar: room.avatar || this.defaultAvatar,
            receiveId: room.receiveId === this.$store.state.user.uid ? room.belongUserId : room.receiveId,
            lastMessage: room.lastContent || room.subtitle || '',
            lastTime: room.lastTime ? new Date(room.lastTime) : (room.time ? new Date(room.time) : new Date()),
            unreadCount: room.unreadCount || room.unread || 0,
            // 保存原始房间信息
            roomInfo: room,
            // 保存其他可能需要的属性
            sessionId: room.sessionId,
            uid: room.uid
          }));
          
          
          // 检查当前聊天是否需要刷新
          for (let i = 0; i < this.chatList.length; i++) {
            const chat = this.chatList[i];
            if (chat.id === messageVo.roomId || 
                chat.receiveId === messageVo.toUserId || 
                chat.receiveId === messageVo.fromUserId) {
              
              // 如果当前正在这个聊天，刷新消息
              if (currentChatId === chat.id || 
                  this.currentChat && this.currentChat.receiveId === chat.receiveId) {
                
                // 重新加载消息，保留临时消息
                this.messages = this.messages.filter(msg => msg.id && msg.id.startsWith('temp_'));
                // 清理临时消息相关状态
                if (this.processedMessages) {
                  this.processedMessages.clear();
                }
                this.loadMessages(chat);
              }
            }
          }
        }
      }).catch(error => {
        console.error("刷新聊天列表失败:", error);
      });
    },
    
    // 处理聊天消息
    handleChatMessage(message) {
      // 收到新消息
      
      // 简化的消息去重逻辑
      if (!this.processedMessages) {
        this.processedMessages = new Set();
      }
      
      const messageKey = message.uid || `${message.fromUserId}_${message.message}_${message.sendTime}`;
      
      if (this.processedMessages.has(messageKey)) {
        return; // 重复消息，跳过处理
      }
      
      this.processedMessages.add(messageKey);
      
      // 获取当前用户信息
      const currentUserInfo = this.$store.state.user.userInfo || {};
      const currentUserUid = currentUserInfo.uid || currentUserInfo.userUid;
      
      // 判断消息是否是自己发送的（多重判断，避免因uid未加载导致误判）
      const isSelf = (currentUserUid && String(message.fromUserId) === String(currentUserUid)) || 
        message.isSelf === true ||
        (this.currentChat && message.toUserId && message.toUserId === this.currentChat.receiveId);
      
      // 优先检查当前聊天是否匹配（包括新聊天）
      if (this.currentChat) {
        const isCurrentChatMatch = 
          // 匹配roomId（如果都有的话）
          (this.currentChat.id && message.roomId && this.currentChat.id === message.roomId) ||
          // 匹配receiveId（对于新聊天或没有roomId的情况）
          (this.currentChat.receiveId === message.fromUserId) ||
          (this.currentChat.receiveId === message.toUserId) ||
          // 特殊处理：新聊天状态下的消息匹配
          (this.currentChat.isNewChat && 
           ((isSelf && this.currentChat.receiveId === message.toUserId) ||
            (!isSelf && this.currentChat.receiveId === message.fromUserId)));
        
        if (isCurrentChatMatch) {
          // 如果消息匹配当前聊天，直接更新当前聊天
          this.updateCurrentChatMessage(message, isSelf);
          
          // 清理过期的消息记录（保留最近200条）
          if (this.processedMessages.size > 200) {
            const entries = Array.from(this.processedMessages);
            this.processedMessages = new Set(entries.slice(-100));
          }
          
          return;
        }
      }
      
      // 查找或创建聊天
      let chatIndex = this.chatList.findIndex(chat => 
        (chat.id && chat.id === message.roomId) || 
        (chat.receiveId === message.fromUserId) || 
        (chat.receiveId === message.toUserId)
      );
      
      if (chatIndex === -1) {
        // 如果找不到对应的聊天，才刷新聊天列表以获取最新数据
        this.refreshRoomList(message);
      } else {
        // 找到对应聊天，直接更新聊天信息，避免重复刷新
        this.updateChatInfo(chatIndex, message, isSelf);
      }
      
      // 清理过期的消息记录（保留最近200条）
      if (this.processedMessages.size > 200) {
        const entries = Array.from(this.processedMessages);
        this.processedMessages = new Set(entries.slice(-100));
      }
    },
    
    // 更新当前聊天消息（用于新聊天）
    updateCurrentChatMessage(message, isSelf) {
      // 获取当前用户信息
      const currentUserInfo = this.$store.state.user.userInfo || {};
      
      // 更新当前聊天的最后消息信息
      if (this.currentChat) {
        this.currentChat.lastMessage = this.formatChatPreview(message.message);
        this.currentChat.lastTime = new Date(message.sendTime || Date.now());
        
        // 如果消息有roomId，更新当前聊天的id并标记为非新聊天
        if (message.roomId && (!this.currentChat.id || this.currentChat.isNewChat)) {
          this.currentChat.id = message.roomId;
          this.currentChat.isNewChat = false;
          
          // 同时更新chatList中对应的聊天记录
          const chatIndex = this.chatList.findIndex(chat => 
            chat.receiveId === this.currentChat.receiveId
          );
          if (chatIndex !== -1) {
            this.chatList[chatIndex].id = message.roomId;
            this.chatList[chatIndex].isNewChat = false;
          }
        }
      }
      
      // 添加消息到当前消息列表
      this.addMessageToCurrentChat(message, isSelf, currentUserInfo);
    },
    
    // 添加消息到当前聊天
    addMessageToCurrentChat(message, isSelf, currentUserInfo) {

      
      // 如果是自己发送的消息，先查找是否有对应的临时消息需要替换
      if (isSelf && message.uid) {
        // 查找最近的临时消息进行替换（优化匹配逻辑）
        const norm = (txt) => (txt || '').toString().trim().replace(/\s+/g, ' ');
        const targetContent = norm(message.message);
        const targetFromId = String(message.fromUserId || '');
        // 在所有消息中查找临时消息，优先匹配内容和发送者
        const tempMessageIndex = this.messages.findIndex(m => {
          if (!m || !m.isTemporary) return false;
          const contentMatch = norm(m.content) === targetContent;
          const senderMatch = String(m.fromUserId || '') === targetFromId || m.isSelf === true;
          // 如果内容和发送者都匹配，则认为是同一条消息，不再严格限制时间
          return contentMatch && senderMatch;
        });
        const adjustedIndex = tempMessageIndex;
        
        if (adjustedIndex !== -1) {
          // 替换临时消息
          const userNickname = currentUserInfo.nickName || currentUserInfo.nickname || currentUserInfo.userName || '我';
          const userAvatar = this.currentUserAvatarUrl || this.defaultAvatar;
          
          const finalMessage = {
            id: message.uid,
            content: message.message,
            message: message.message,
            category: message.category || 20001,
            createTime: new Date(message.sendTime || Date.now()),
            sendTime: message.sendTime || Date.now(),
            avatar: userAvatar,
            nickname: userNickname,
            fromUserNickName: userNickname,
            userTag: message.userTag,
            userLevel: message.userLevel,
            gender: message.gender,
            userIpPossession: message.userIpPossession,
            fromUserId: String(message.fromUserId),
            isSelf: true,
            isTemporary: false // 标记为非临时消息
          };
          
          // 使用Vue.set确保响应式更新
          this.$set(this.messages, adjustedIndex, finalMessage);
          return;
        } else {
          // 如果没有找到对应的临时消息，清理所有过期的临时消息（超过30秒）
          const now = Date.now();
          this.messages = this.messages.filter(m => {
            if (m.isTemporary && (now - (m.sendTime || m.createTime || 0)) > 30000) {
              return false;
            }
            return true;
          });
        }
      }
      
      // 优化消息去重逻辑
      const existingIndex = this.findDuplicateMessage(message);
      
      if (existingIndex === -1) {
        // 添加消息到列表
        const userNickname = isSelf ? (currentUserInfo.nickName || currentUserInfo.nickname || currentUserInfo.userName || '我') : (message.fromUserNickName || '未知用户');
        
        // 获取头像
        let userAvatar;
        if (isSelf) {
          userAvatar = this.currentUserAvatarUrl || this.defaultAvatar;
        } else {
          // 简化的头像获取逻辑
          userAvatar = this.getValidAvatar(message.fromUserAvatar) !== this.defaultAvatar ? 
            this.getValidAvatar(message.fromUserAvatar) :
            this.getValidAvatar(this.currentChat && this.currentChat.avatar) !== this.defaultAvatar ?
            this.getValidAvatar(this.currentChat.avatar) :
            (() => {
              const chatUser = this.chatList.find(chatItem => 
                chatItem.receiveId === message.fromUserId || 
                (chatItem.userInfo && chatItem.userInfo.uid === message.fromUserId)
              );
              return this.getValidAvatar(chatUser && chatUser.avatar);
            })();
        }
        
        // 创建新消息对象，确保唯一ID
        const messageId = message.uid || `msg_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;

        
        const newMessage = {
          id: messageId,
          content: message.message,
          message: message.message,
          category: message.category || 20001,
          createTime: new Date(message.sendTime || Date.now()),
          sendTime: message.sendTime || Date.now(),
          avatar: userAvatar,
          nickname: userNickname,
          fromUserNickName: userNickname,
          userTag: message.userTag,
          userLevel: message.userLevel,
          gender: message.gender,
          userIpPossession: message.userIpPossession,
          fromUserId: isSelf ? currentUserInfo.uid : message.fromUserId,
          isSelf: isSelf
        };
        
        // 使用push方法添加消息
        this.messages.push(newMessage);
        // 消息已添加到数组
        
        // 滚动到底部
        this.$nextTick(() => {
          this.scrollToBottom();
          // 消息已添加并滚动到底部
        });
      }
    },
    
    // 更新聊天信息（确保响应式更新）
    updateChatInfo(chatIndex, message, isSelf) {
      // 收到消息，更新聊天信息
      
      // 获取当前聊天对象
      let chatInfo = this.chatList[chatIndex];
      if (!chatInfo) {
        return;
      }
      
      // 创建新的chatList数组，确保响应式更新
      const newChatList = [...this.chatList];
      
      // 创建更新后的聊天对象
      const updatedChat = {
        ...chatInfo,
        lastTime: new Date(message.sendTime || Date.now())
      };
      
      // 非当前聊天室的消息，需要加未读消息数量显示
      // 简化判断逻辑：只要不是自己发送的消息，且不是当前正在查看的聊天，就增加未读计数
      const isCurrentChat = this.currentChat && (
        (this.currentChat.id && this.currentChat.id === message.roomId) ||
        (this.currentChat.receiveId === message.fromUserId) ||
        (this.currentChat.receiveId === message.toUserId)
      );
      
      if (!isSelf && !isCurrentChat) {
        updatedChat.unreadCount = (chatInfo.unreadCount || 0) + 1;
      }
      
      // 更新最后消息
      if (message.category == 20001) {
        updatedChat.lastMessage = `${message.fromUserNickName}: ${message.message}`;
      } else if (message.category == 20002) {
        updatedChat.lastMessage = `${message.fromUserNickName}: [语音]`;
      } else if (message.category == 20003) {
        updatedChat.lastMessage = `${message.fromUserNickName}: [图片]`;
      } else if (message.category == 20004) {
        updatedChat.lastMessage = `${message.fromUserNickName}: [视频通话]`;
      } else if (message.category == 20005) {
        updatedChat.lastMessage = `${message.fromUserNickName}: [语音通话]`;
      } else {
        updatedChat.lastMessage = `${message.fromUserNickName}: [媒体消息]`;
      }
      
      // 更新数组中的聊天对象
      newChatList[chatIndex] = updatedChat;
      
      // 使用数组赋值方式确保响应式更新（与loadChatList保持一致）
      this.chatList = newChatList;
      
      // 只有在未读数实际变化时才通知父组件
      this.$nextTick(() => {
        if (!isSelf && !isCurrentChat) {
          this.notifyUnreadCountChange();
        }
      });
      
      
      // 如果是当前聊天，添加消息到当前消息列表
      if (this.currentChat && 
          ((this.currentChat.id && this.currentChat.id === message.roomId) || 
           (!this.currentChat.id && (this.currentChat.receiveId === message.fromUserId || this.currentChat.receiveId === message.toUserId)) || 
           (this.currentChat.id && (this.currentChat.receiveId === message.fromUserId || this.currentChat.receiveId === message.toUserId)))) {
        
        // 优化消息去重逻辑 - 放宽重复检查条件
        const existingIndex = this.findDuplicateMessage(message);
        if (existingIndex === -1) {
          // 获取当前用户信息（必须在使用前声明）
          const currentUserInfo = this.$store.state.user.userInfo || {};
          const currentUserUid = currentUserInfo.uid || currentUserInfo.userUid;
          
          // 添加消息到列表
          const userNickname = isSelf ? (currentUserInfo.nickName || currentUserInfo.nickname || currentUserInfo.userName || '我') : (message.fromUserNickName || '未知用户');
          
          // 获取头像
          let userAvatar;
          if (isSelf) {
            userAvatar = this.getCurrentUserAvatar();
          } else {
            userAvatar = this.getValidAvatar(message.fromUserAvatar) !== this.defaultAvatar ?
              message.fromUserAvatar : this.defaultAvatar;
          }
          
          
          // 创建新消息对象
          const newMessage = {
            id: message.uid || Date.now().toString(),
            content: message.message,
            message: message.message,
            category: message.category || 20001,
            createTime: new Date(message.sendTime || Date.now()),
            sendTime: message.sendTime || Date.now(),
            avatar: userAvatar,
            nickname: userNickname,
            fromUserNickName: userNickname,
            userTag: message.userTag,
            userLevel: message.userLevel,
            gender: message.gender,
            userIpPossession: message.userIpPossession,
            fromUserId: isSelf ? currentUserUid : message.fromUserId,
            isSelf: isSelf  // 确保isSelf字段正确设置
          };
          

          
          // 使用push方法添加消息
          this.messages.push(newMessage);
          
          // 滚动到底部
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        }
      }
      
    },
    
    // 查找重复消息 - 优化去重逻辑，支持多种去重方式
    findDuplicateMessage(message) {
      return this.messages.findIndex(m => {
        // 优先使用消息ID进行去重
        if (message.uid && m.id === message.uid) {
          return true;
        }
        
        // 即使message.uid存在，也要检查是否有匹配的临时消息（防止isSelf误判时遗漏）
        if (m.isTemporary) {
          const norm = (txt) => (txt || '').toString().trim().replace(/\s+/g, ' ');
          const isSameContent = norm(m.content) === norm(message.message);
          // 判断这条消息是否是自己发的回显（toUserId等于聊天对象）
          const messageIsFromSelf = message.toUserId && this.currentChat && message.toUserId === this.currentChat.receiveId;
          if (isSameContent && messageIsFromSelf) {
            return true;
          }
        }
        
        // 如果没有ID，使用内容、时间和发送者进行去重
        if (!message.uid) {
          const isSameContent = m.content === message.message || m.message === message.message;
          // 放宽时间匹配条件到5秒内，避免因网络延迟导致的时间差异
          const isSameTime = Math.abs(new Date(m.sendTime || m.createTime).getTime() - new Date(message.sendTime).getTime()) < 5000;
          const isSameSender = m.fromUserId === message.fromUserId;
          
          // 只有在内容、发送者和时间都完全匹配时才认为是重复
          return isSameContent && isSameTime && isSameSender;
        }
        
        return false;
      });
    },
    
    // 发送消息 (与ChatRoom组件的sendMessage方法一致)
    sendMessage() {
      if (!this.inputMessage.trim()) return;
      
      if (!this.currentChat) {
        this.$message.warning("请先选择聊天对象");
        return;
      }
      
      // 获取消息内容后立即清空输入框
      const messageContent = this.inputMessage.trim();
      this.inputMessage = "";
      
      // 获取当前用户信息
      const currentUserInfo = this.$store.state.user.userInfo || {};
      const currentUserUid = currentUserInfo.uid || currentUserInfo.userUid;
      const currentUserNickname = currentUserInfo.nickName || currentUserInfo.nickname || currentUserInfo.userName || '我';
      
      // 获取当前用户头像
      const userAvatar = this.getCurrentUserAvatar();
      
      // 检查是否已经有相同内容的临时消息存在（5秒内的重复才算重复）
      const now = Date.now();
      const existingTempIndex = this.messages.findIndex(m => 
        m.content === messageContent && 
        m.id && m.id.startsWith('temp_') && 
        m.isSelf === true &&
        (now - (m.sendTime || m.createTime || 0)) < 5000 // 只有5秒内的才算重复
      );
      
      if (existingTempIndex === -1) {
        // 没有重复的临时消息，添加新的临时消息
        const immediateMessage = {
          id: 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
          content: messageContent,
          message: messageContent,
          category: 20001,
          createTime: new Date(),
          sendTime: Date.now(),
          avatar: userAvatar,
          nickname: currentUserNickname,
          fromUserNickName: currentUserNickname,
          userTag: currentUserInfo.userTag || 0,
          userLevel: currentUserInfo.userLevel || 1,
          gender: currentUserInfo.gender || '1',
          userIpPossession: '',
          fromUserId: currentUserUid,
          isSelf: true, // 标记为自己发送的消息
          isTemporary: true // 标记为临时消息
        };
        
        this.messages.push(immediateMessage);
        
        // 设置临时消息的自动清理机制（30秒后如果还是临时状态就清理）
        setTimeout(() => {
          const normalizeText = (txt) => (txt || '').toString().trim().replace(/\s+/g, ' ');
          const tempIndex = this.messages.findIndex(m => 
            m.isTemporary && 
            normalizeText(m.content) === normalizeText(messageContent) && 
            m.isSelf === true
          );
          if (tempIndex !== -1) {
            this.messages.splice(tempIndex, 1);
          }
        }, 30000);
        
        // 滚动到底部
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      } else {
        // 如果已存在相同内容的临时消息，不重复创建，也不发送消息

        this.$message.warning('请勿重复发送相同内容的消息');
        return; // 直接返回，不执行后续的发送逻辑
      }
      
      // 更新聊天列表中的最后一条消息
      if (this.currentChat) {
        this.currentChat.lastMessage = messageContent;
        this.currentChat.lastTime = new Date();
        
        // 更新chatList中对应的聊天项
        const chatIndex = this.chatList.findIndex(chat => 
          chat.id === this.currentChat.id || chat.receiveId === this.currentChat.receiveId
        );
        if (chatIndex !== -1) {
          this.chatList[chatIndex].lastMessage = messageContent;
          this.chatList[chatIndex].lastTime = new Date();
        }
      }
      
      // 判断是否为新聊天
      const isNewChat = this.currentChat.isNewChat || !this.currentChat.id || this.currentChat.id.startsWith('user_');
            
      if (isNewChat) {
        // 新聊天：只发10010（后端会同时创建会话+持久化消息）
        // 不能再发10001，否则消息会被存储两次
        const newRoomMessage = {
          messageType: 10010, // 新聊天通知
          messageLevel: 10003,
          category: 20001,
          toUserId: this.currentChat.receiveId,
          toUserAvatar: this.currentChat.avatar,
          toUserNickName: this.currentChat.name,
          message: messageContent,
        };
              
        this.doSend(newRoomMessage);
              
        // 延迟刷新聊天列表
        setTimeout(() => {
          this.refreshRoomList({
            toUserId: this.currentChat.receiveId
          });
        }, 1000);
      } else {
        // 已有会话：发10001普通私聊消息
        const messageVo = {
          messageType: this.currentChat.roomType || 10001,
          message: messageContent,
          category: 20001,
          toUserId: this.currentChat.receiveId,
          roomId: this.currentChat.id,
          messageLevel: 10003,
          fromUserId: currentUserUid,
          sendTime: new Date().getTime()
        };
              
        this.doSend(messageVo);
      }
    },
    
    // 发送WebSocket消息
    doSend(messageVo) {
      // 使用统一的WebSocket管理器发送消息
      webSocketManager.sendMessage(messageVo);
    },
    
    // 选择图片
    openImageUpload() {
      // 调用Element UI的上传组件或自定义上传方法
      this.$message.info("图片上传功能正在开发中");
    },
    
    // 发起视频通话
    openVideoCall() {
      if (!this.currentChat) {
        this.$message.warning("请先选择聊天对象");
        return;
      }
      this.$message.info("视频通话功能正在开发中");
    },
    
    // 发起音频通话
    openAudioCall() {
      if (!this.currentChat) {
        this.$message.warning("请先选择聊天对象");
        return;
      }
      this.$message.info("音频通话功能正在开发中");
    },
    
    // 预览图片
    previewImage(url) {
      if (!url) return;
      
      this.previewImageUrl = url;
      this.showImageViewer = true;
    },
    
    // 关闭图片预览
    closeImageViewer() {
      this.showImageViewer = false;
    },
    
    // 跳转到用户中心页面
    getUserCenter(userUid) {
      if (!userUid) return;
      
      let routeData = this.$router.resolve({
        path: "/userCenter",
        query: { userUid: userUid }
      });
      window.open(routeData.href, '_blank');
    },
    
    // 格式化时间
    formatTime(time) {
      if (!time) return '';
      
      const date = new Date(time);
      if (isNaN(date.getTime())) return '';
      
      // 获取当前日期
      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);
      
      // 判断是否为今天
      if (date >= today) {
        return this.formatHHMM(date);
      } 
      // 判断是否为昨天
      else if (date >= yesterday) {
        return '昨天 ' + this.formatHHMM(date);
      } 
      // 判断是否为今年
      else if (date.getFullYear() === now.getFullYear()) {
        return this.formatMMDD(date) + ' ' + this.formatHHMM(date);
      } 
      // 其他情况显示完整日期
      else {
        return this.formatYYYYMMDD(date) + ' ' + this.formatHHMM(date);
      }
    },
    
    formatHHMM(date) {
      return `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
    },
    
    formatMMDD(date) {
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
    },
    
    formatYYYYMMDD(date) {
      return `${date.getFullYear()}-${this.formatMMDD(date)}`;
    },
    
    // 获取用户信息
    getUserInfo(uid) {
      this.$router.push({
        path: '/about',
        query: { userUid: uid }
      });
    },
    
    // 聚焦到输入框
    focusInput() {
      this.$nextTick(() => {
        if (this.$refs.messageInput) {
          this.$refs.messageInput.focus();
        }
      });
    },
    
    // 关闭对话框
    closeDialog() {
      // 设置强制关闭标记
      this.forceClosed = true;
      // 先关闭WebSocket，再更新对话框状态
      this.closeAllSocketConnections();
      // 通过设置内部状态来关闭弹窗，这将触发watcher并发送事件到父组件
      this.internalDialogVisible = false;
    },
    
    // 清理聊天相关资源
    closeAllSocketConnections() {
      // 设置强制关闭标记
      this.forceClosed = true;
      
      // 清理已处理消息集合，避免重复消息问题
      if (this.processedMessages) {
        this.processedMessages.clear();
      }
      
      // 移除WebSocket消息处理器
      this.unregisterWebSocketHandlers();
      
      // WebSocket连接由统一管理器处理，这里只需要重置状态
      this.isConnecting = false;
    },
    
    // 获取用户等级文本
    getUserLevelText(level) {
      if (!level) return '';
      const levelMap = {
        1: '初出茅庐',
        2: '初级',
        3: '中级',
        4: '高级',
        5: '专家'
      };
      return levelMap[level] || '初出茅庐';
    },
    
    getUserTag(tagValue) {
      if (!tagValue || !this.userTagDictList || !this.userTagDictList.length) return null;
      
      // VIP等级映射
      const vipLevelMap = {
        16: 'VIP',
        17: 'SVIP', 
        18: 'SSVIP',
        19: 'MAX'
      };
      
      // 如果是VIP等级，返回对应的标识
      if (vipLevelMap[tagValue]) {
        return {
          dictValue: tagValue,
          dictLabel: vipLevelMap[tagValue],
          remark: vipLevelMap[tagValue]
        };
      }
      
      // 其他情况按原逻辑处理
      const tag = this.userTagDictList.find(tag => tag.dictValue == tagValue);
      return tag || null;
    },

    getUserLevel(levelValue) {
      if (!levelValue || !this.userLevelDictList || !this.userLevelDictList.length) return null;
      const level = this.userLevelDictList.find(level => level.dictValue == levelValue);
      return level ? level.remark : null;
    },

    timeAgo(timestamp) {
      if (!timestamp) return '';
      
      const date = new Date(timestamp);
      const now = new Date();
      const diff = Math.floor((now.getTime() - date.getTime()) / 1000);
      
      if (diff < 60) return '刚刚';
      if (diff < 3600) return Math.floor(diff / 60) + '分钟前';
      if (diff < 86400) return Math.floor(diff / 3600) + '小时前';
      if (diff < 2592000) return Math.floor(diff / 86400) + '天前';
      if (diff < 31536000) return Math.floor(diff / 2592000) + '月前';
      return Math.floor(diff / 31536000) + '年前';
    },

    loadMore() {
      this.loadingMore = true;
      this.currentPage += 1;
      
      // 加载更多聊天历史记录
      history({
        roomId: this.currentChat.id.startsWith('user_') ? '' : this.currentChat.id,
        toUserId: this.currentChat.receiveId,
        page: this.currentPage,
        pageSize: this.pageSize
      }).then(response => {
        this.loadingMore = false;
        
        // 检查响应结构
        let records = [];
        if (response.data && response.data.records) {
          records = response.data.records;
        } else if (Array.isArray(response.data)) {
          records = response.data;
        }
        
        if (records.length > 0) {
          // 获取当前用户信息，用于判断消息是否为自己发送
          const currentUserInfo = this.$store.state.user.userInfo || {};
          const currentUserUid = currentUserInfo.uid;
          const currentUserNickname = currentUserInfo.nickname || currentUserInfo.nickName || currentUserInfo.userName;
          
          
          const historyMessages = records.map(msg => {
            
            // 判断消息是否为空
            if (!msg.message && !msg.content) {
              return null;
            }
            
            const fromUserId = msg.fromUserId || msg.senderId || '';
            const fromNickname = msg.fromUserNickName || msg.nickname || '';
            
            // 判断消息是否是自己发送的 - 检查发送者ID或昵称与当前用户是否匹配
            const isSelf = 
              (currentUserUid && fromUserId === currentUserUid) || 
              (currentUserNickname && fromNickname === currentUserNickname); // 特殊处理，根据您的截图中的用户名
            
            // 增强判断 - 如果上面的判断无法确定，使用其他方法
            const enhancedSelfCheck = isSelf || 
                (this.currentChat && this.currentChat.receiveId && msg.toUserId && msg.toUserId === this.currentChat.receiveId) ||
                (fromNickname === '我') ||
                (msg.toUserName && this.currentChat && this.currentChat.name && msg.toUserName !== this.currentChat.name);
            
            
            // 使用与handleChatMessage相同的逻辑获取用户信息
            const userNickname = enhancedSelfCheck ? (currentUserInfo.nickName || currentUserInfo.nickname || currentUserInfo.userName || fromNickname || '我') : (fromNickname || msg.fromUserNickName || '未知用户');
            
            // 使用相同的头像获取逻辑
            let userAvatar;
            if (enhancedSelfCheck) {
              // 对于自己发送的消息，使用优化的头像获取逻辑
              userAvatar = this.currentUserAvatarUrl;
              
              // 如果当前存储的头像为空或为默认头像，重新获取
              if (!userAvatar || userAvatar === this.defaultAvatar || userAvatar.includes('defaultAvatar.png')) {
                // 重新调用头像获取方法
                this.storeCurrentUserAvatar();
                userAvatar = this.currentUserAvatarUrl;
                
                // 如果仍然获取不到，尝试直接从页面元素获取
                if (!userAvatar || userAvatar === this.defaultAvatar || userAvatar.includes('defaultAvatar.png')) {
                  const headerAvatars = [
                    '.el-header .el-avatar img',
                    '.header .el-avatar img', 
                    '.userinfo img',
                    '.el-dropdown-link img',
                    '.user-avatar img',
                    '.avatar img',
                    'img[src*="photoUrl"]',
                    'img[src*="avatar"]'
                  ];
                  
                  for (const selector of headerAvatars) {
                    const imgElement = document.querySelector(selector);
                    if (imgElement && imgElement.src && 
                        !imgElement.src.includes('defaultAvatar.png') && 
                        !imgElement.src.includes('favicon.png') &&
                        !imgElement.src.includes('default.png')) {
                      userAvatar = imgElement.src;
                      // 同时更新存储的头像
                      this.currentUserAvatarUrl = imgElement.src;
                      break;
                    }
                  }
                }
                
                // 最后的fallback
                if (!userAvatar || userAvatar === this.defaultAvatar || userAvatar.includes('defaultAvatar.png')) {
                  userAvatar = this.defaultAvatar;
                }
              }
            } else {
              // 对于其他用户的消息，优先从当前聊天对象获取头像
              if (this.currentChat && this.currentChat.avatar && !this.currentChat.avatar.includes('defaultAvatar.png')) {
                userAvatar = this.currentChat.avatar;
              } else if (msg.fromUserAvatar && !msg.fromUserAvatar.includes('defaultAvatar.png')) {
                userAvatar = msg.fromUserAvatar;
              } else {
                // 检查当前聊天列表中是否有该用户的头像信息
                const chatUser = this.chatList.find(chatItem => 
                  chatItem.receiveId === fromUserId || 
                  chatItem.name === fromNickname ||
                  (chatItem.userInfo && chatItem.userInfo.uid === fromUserId)
                );
                
                if (chatUser && chatUser.avatar && !chatUser.avatar.includes('defaultAvatar.png')) {
                  userAvatar = chatUser.avatar;
                } else {
                  userAvatar = this.defaultAvatar;
                }
              }
            }
            
            return {
              id: msg.uid,
              content: msg.message || msg.content || '',
              message: msg.message || msg.content || '',
              category: msg.category || 20001,
              createTime: msg.createTime || msg.sendTime || Date.now(),
              sendTime: msg.sendTime || msg.createTime || Date.now(),
              avatar: userAvatar,
              nickname: userNickname,
              fromUserNickName: userNickname,
              userTag: msg.userTag || 0,
              userLevel: msg.userLevel || 1,
              gender: msg.gender || '1',
              userIpPossession: msg.userIpPossession || '',
              fromUserId: fromUserId,
              isSelf: enhancedSelfCheck  // 使用增强的判断结果
            };
          }).filter(msg => msg !== null);
          
          // 在消息列表前面添加历史消息
          this.messages = [...historyMessages, ...this.messages];
          
          // 检查是否还有更多历史记录
          this.hasMore = records.length >= this.pageSize;
        } else {
          this.hasMore = false;
        }
      }).catch(error => {

        this.loadingMore = false;
        this.hasMore = false;
      });
    },
    
    // 通知父组件聊天未读数变化（防止重复触发）
    notifyUnreadCountChange() {
      const currentCount = this.totalChatUnreadCount;
      if (this.lastNotifiedCount !== currentCount) {
        this.lastNotifiedCount = currentCount;
        this.$emit('chat-unread-changed', currentCount);

      }
    },
    
    // 清空所有未读计数（供父组件调用）
    clearAllUnreadCounts() {

      // 清空所有聊天的未读计数
      this.chatList.forEach(chat => {
        if (chat.unreadCount > 0) {
          chat.unreadCount = 0;
        }
      });
      
      // 重置相关状态
      this.lastNotifiedCount = 0;
      
      // 通知父组件未读数变化
      this.notifyUnreadCountChange();
    },
    
    // 表情相关方法
    toggleEmojiPanel() {
      this.showEmojiPanel = !this.showEmojiPanel;
    },
    
    insertEmoji(emoji) {
      // 如果没有选择聊天对象，提示用户
      if (!this.currentChat) {
        this.$message.warning("请先选择聊天对象");
        return;
      }
      
      // 获取表情图片URL
      const emojiUrl = '/static/images/emoji/' + emoji;
      
      // 构建表情消息内容
      const emojiContent = `<img src="${emojiUrl}" class="chat-msg-emoji" width="24" height="24" style="height: 24px;width: 24px; display: inline-block; vertical-align: middle;">`;
      
      // 构建消息对象
      const messageVo = {
        messageType: 10001, // 普通消息
        category: 20001, // 文本消息类型(包含emoji的文本)
        message: emojiContent,
        toUserId: this.currentChat.receiveId,
        roomId: this.currentChat.id && !this.currentChat.id.startsWith('user_') ? this.currentChat.id : '',
        messageLevel: 10003,
        fromUserId: this.$store.state.user.userInfo && this.$store.state.user.userInfo.uid // 显式设置发送者ID为当前用户
      };
      
      // 发送消息到服务器，等待服务器回传后再显示
      this.doSend(messageVo);
      
      // 关闭表情面板
      this.showEmojiPanel = false;
    },
    
    handleClickOutside(event) {
      const emojiWrapper = this.$refs.emojiWrapper;
      if (emojiWrapper && !emojiWrapper.contains(event.target)) {
        this.showEmojiPanel = false;
      }
    },
  }
}
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: row;
  height: calc(100vh - 450px); /* 基于当前屏幕最大高度减去150px */
  overflow: hidden;
}

/* 标题和连接图标样式 */
.dialog-title {
  display: flex;
  align-items: center;
}

.connecting-icon {
  display: inline-block;
  animation: spin 1s linear infinite;
  margin-right: 5px;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* 临时消息样式 */
.temp-msg {
  animation: fadeIn 0.5s ease;
  position: relative;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.temp-msg::after {
  content: '';
  /* position: absolute; */
  bottom: 5px;
  right: 5px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background-color: #95ec69;
  animation: blink 1s infinite;
}

@keyframes blink {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.3; }
}

/* 左侧聊天列表样式 */
.chat-sidebar {
  width: 30%;
  height: 100%;
  border-right: 1px solid #e8e8e8;
  display: flex;
  flex-direction: column;
}

.chat-search {
  padding: 10px;
  border-bottom: 1px solid #e8e8e8;
}

.chat-list {
  flex: 1;
  overflow-y: auto;
}

.chat-item {
  display: flex;
  align-items: center;
  padding: 8px 10px;
  cursor: pointer;
  border-bottom: 1px solid #f5f5f5;
  position: relative;
  height: 50px;
}

.chat-item:hover, .chat-item.active {
  background-color: #f5f5f5;
}

.chat-avatar {
  margin-right: 10px;
  flex-shrink: 0;
}

.vip-border {
  border: 2px solid #ff9800;
}

.chat-info {
  flex: 1;
  overflow: hidden;
}

.chat-name-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 3px;
}

.chat-name {
  font-weight: 500;
  color: #333;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 120px;
}

.chat-time {
  font-size: 12px;
  color: #999;
  white-space: nowrap;
}

.chat-preview-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.chat-preview {
  color: #999;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 140px;
}

.unread-count {
  background-color: #f56c6c;
  color: white;
  border-radius: 10px;
  min-width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  font-size: 12px;
  padding: 0 6px;
}

.empty-state {
  text-align: center;
  padding: 20px;
  color: #999;
}

.login-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
}

.login-prompt i {
  display: block;
}

.login-prompt p {
  font-size: 14px;
  line-height: 1.5;
}

/* 右侧聊天内容样式 */
.chat-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  background-color: #f5f5f5;
  overflow: hidden; /* 防止出现双滚动条 */
  height: 100%; /* 确保高度占满父容器 */
}

.chat-header {
  height: 60px;
  padding: 0 20px;
  background-color: #f5f5f5;
  border-bottom: 1px solid #e7e7e7;
  display: flex;
  align-items: center;
}

.chat-title {
  font-size: 16px;
  font-weight: 500;
}

.message-area {
  flex: 1;
  overflow: hidden;
  position: relative;
  display: flex;
  flex-direction: column;
}

/* 聊天消息样式 */
.msg-list {
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 10px 10px 40px 10px; /* 底部增加更多内边距 */
  overflow-x: hidden;
  margin: 0;
  list-style: none;
}

.msg-item {
  margin-top: 15px;
  clear: both;
  width: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  animation: fade-in 0.3s ease-out;
  margin-bottom: 30px; /* 增加更多底部间距 */
  padding-bottom: 10px;
}

.msg-item:last-child {
  margin-bottom: 30px; /* 增加更多底部间距 */
  padding-bottom: 10px;
}

.msg-avatar {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  flex-shrink: 0;
  margin-right: 10px;
  margin-top: 4px;
}

.msg-info {
  max-width: calc(100% - 60px);
  position: relative;
  display: inline-block;
}

.msg-header {
  font-size: 12px;
  color: #999;
  margin-bottom: 5px;
}

.send-user {
  color: #000000;
  font-weight: bold;
  margin-right: 5px;
}

.send-time {
  color: #999;
  margin-left: 5px;
  font-size: 11px;
}

.msg-content {
  margin: 0;
  word-break: break-word;
  line-height: 1.5;
  background-color: transparent !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  white-space: pre-wrap;
  max-width: 100%;
}

/* 左侧消息容器样式 */
.msg-left-content-container {
  padding: 10px 12px;
  background-color: #fff;
  border-radius: 4px;
  position: relative;
  display: inline-block;
  text-align: left;
  max-width: 80%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  border-left: 3px solid #dcdfe6;
}

.msg-left-content-container:before {
  content: '';
  position: absolute;
  top: 12px;
  left: -8px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 8px 6px 0;
  border-color: transparent #fff transparent transparent;
}

/* 右侧消息容器样式 */
.msg-right-content-container {
  padding: 10px 12px;
  background-color: #95ec69;
  border-radius: 4px;
  position: relative;
  display: inline-block;
  text-align: left;
  max-width: 80%;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  word-break: break-word;
  word-wrap: break-word;
  white-space: pre-wrap;
  border-right: 3px solid #67c23a;
}

.msg-right-content-container:after {
  content: '';
  position: absolute;
  top: 12px;
  right: -8px;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 6px 0 6px 8px;
  border-color: transparent transparent transparent #95ec69;
}

.chat-msg-img {
  max-width: 200px;
  max-height: 150px;
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  object-fit: contain;
}

/* VIP用户样式统一规范 */
.vip-avatar {
  position: relative;
  display: inline-block;
}

.vip-text {
  position: absolute;
  background-color: #ff9800;
  color: white;
  font-size: 8px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-weight: bold;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  z-index: 9999;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  text-transform: uppercase;
  border: 2px solid #fff;
}

/* VIP等级样式 - 基于标识文本匹配 */
/* VIP红底金字 */
.vip-text[data-vip="VIP"] {
  background: #ff4757;
  color: #ffd700;
  border: 2px solid #ffd700;
}

/* SVIP蓝底金字 */
.vip-text[data-vip="SVIP"] {
  background: #121ec9;
  color: #ffd700;
  border: 2px solid #ffd700;
}

/* SSVIP黑底金字 */
.vip-text[data-vip="SSVIP"] {
  background: #000000;
  color: #ffd700;
  border: 2px solid #ffd700;
}

/* MAX渐变底白字 */
.vip-text[data-vip="MAX"] {
  background: linear-gradient(45deg, #ff4757, #ffd700);
  color: white;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
}

/* 兼容数值匹配 */
.vip-text[data-vip="16"] {
  background: #ff4757;
  color: #ffd700;
  border: 2px solid #ffd700;
}

.vip-text[data-vip="17"] {
  background: #121ec9;
  color: #ffd700;
  border: 2px solid #ffd700;
}

.vip-text[data-vip="18"] {
  background: #000000;
  color: #ffd700;
  border: 2px solid #ffd700;
}

.vip-text[data-vip="19"] {
  background: linear-gradient(45deg, #ff4757, #ffd700);
  color: white;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
}

/* 兼容文本标识 */
.vip-text[data-vip="VIP"],
.vip-text[data-vip="超级会员"],
.vip-text[data-vip="会员"],
.vip-text[data-vip="vip"] {
  background: #ff4757;
  color: #ffd700;
  border: 2px solid #ffd700;
}

.vip-text[data-vip="SVIP"],
.vip-text[data-vip="svip"] {
  background: #121ec9;
  color: #ffd700;
  border: 2px solid #ffd700;
}



.vip-color {
  border: 2px solid #ff9800;
}

/* 用户等级样式 */
.lv {
  display: inline-block;
  font-size: 10px;
  padding: 0 3px;
  border-radius: 2px;
  color: white;
  background-color: #67c23a;
  margin-left: 3px;
}

.lv1 { background-color: #67c23a; }
.lv2 { background-color: #409eff; }
.lv3 { background-color: #e6a23c; }
.lv4 { background-color: #f56c6c; }
.lv5 { background-color: #909399; }
.lv6 { background-color: #9c27b0; }

.chat-load-more {
  text-align: center;
  cursor: pointer;
  padding: 8px;
  font-size: 13px;
  color: #409eff;
  background-color: #f0f9ff;
  margin: 10px auto 15px auto;
  border-radius: 15px;
  width: 120px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  border: 1px solid #e1f3ff;
}

.chat-load-more:hover {
  background-color: #ecf5ff;
  color: #66b1ff;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.15);
}

.emoji-wrapper {
  position: relative;
  display: inline-block;
}

.emoji-panel {
  position: absolute;
  bottom: 60px;
  left: 10px;
  background-color: white;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  padding: 10px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 100;
  display: flex;
  flex-wrap: wrap;
  width: 360px;
  max-height: 200px;
  overflow-y: auto;
}

.emoji-list {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
}

.emoji-item {
  cursor: pointer;
  padding: 5px;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.emoji-item:hover {
  background-color: #f0f0f0;
}





.load-more-button {
  background-color: #f5f5f5;
  color: #909399;
  border: none;
  border-radius: 4px;
  padding: 6px 12px;
  font-size: 14px;
  cursor: pointer;
  margin: 10px auto;
  display: block;
  text-align: center;
  transition: all 0.3s;
}

.load-more-button:hover {
  background-color: #e0e0e0;
  color: #606266;
}

/* 动画定义 */
@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.connecting-icon {
  display: inline-block;
  animation: spin 1s linear infinite;
  margin-right: 5px;
}



/* WebSocket连接状态指示器 */
.connection-status {
  position: absolute;
  bottom: 10px;
  right: 10px;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  background-color: rgba(0, 0, 0, 0.6);
  color: white;
  z-index: 100;
}

.toolbar i {
  font-size: 22px !important;
  color: #7c7c7c;
  margin-right: 20px;
  cursor: pointer;
  transition: color 0.2s;
  line-height: 1;
}

.toolbar i:hover {
  color: #409EFF !important;
}

.no-chat-selected {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #999;
}

.no-chat-selected i {
  font-size: 50px;
  margin-bottom: 10px;
}

.input-area {
  border-top: 1px solid #e7e7e7;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.toolbar {
  height: 40px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e7e7e7;
}

.message-input {
  padding: 10px;
}

.send-button {
  padding: 0 10px 10px;
  display: flex;
  justify-content: flex-end;
}

.no-chat-selected {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  color: #909399;
}

.no-chat-selected i {
  font-size: 50px;
  margin-bottom: 10px;
}

.no-chat-selected p {
  margin-bottom: 20px;
}

.pointer {
  cursor: pointer;
}

/* VIP图标样式 */
.vip-text {
  position: absolute;
  background: linear-gradient(135deg, #FFD700, #FFA500);
  color: white;
  font-size: 10px;
  font-weight: bold;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid white;
  box-shadow: 0 2px 4px rgba(0,0,0,0.2);
  z-index: 10;
}

/* VIP等级样式 */
/* VIP红底金字 */
.vip-text[data-vip="VIP"] {
  background: #ff4757;
  color: #ffd700;
  border: 2px solid #ffd700;
}

/* SVIP蓝底金字 */
.vip-text[data-vip="SVIP"] {
  background: #121ec9;
  color: #ffd700;
  border: 2px solid #ffd700;
}

/* SSVIP黑底金字 */
.vip-text[data-vip="SSVIP"] {
  background: #000000;
  color: #ffd700;
  border: 2px solid #ffd700;
}

/* MAX渐变底白字 */
.vip-text[data-vip="MAX"] {
  background: linear-gradient(45deg, #ff4757, #ffd700);
  color: white;
  border: 2px solid white;
  box-shadow: 0 2px 8px rgba(255, 71, 87, 0.4);
}

/* 动画效果 */
@keyframes fade-in {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 对方发送的消息 */
.msg-item > div:first-child:not([style*="text-align: right"]) {
  display: flex;
  align-items: flex-start;
  margin-bottom: 5px;
}

/* 自己发送的消息 */
.msg-item > [style*="text-align: right"] {
  display: flex;
  flex-direction: row-reverse;
  align-items: flex-start;
  justify-content: flex-start;
  margin-bottom: 5px;
}

.msg-item > [style*="text-align: right"] .msg-info {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-right: 10px;
  max-width: calc(100% - 60px);
}

/* 自己发送消息特殊处理 - 确保内容区域和气泡宽度合适 */
.msg-item > [style*="text-align: right"] .msg-right-content-container {
  max-width: 80%;
  display: inline-block;
  text-align: left;
}

.msg-item > div:first-child:not([style*="text-align: right"]) .msg-left-content-container {
  max-width: 80%;
  display: inline-block;
}

/* 添加适当的内外边距以防止文本靠太近边缘 */
.msg-right-content-container .msg-content,
.msg-left-content-container .msg-content {
  padding: 0;
  margin: 0;
  max-width: 100%;
}




</style>

<style>
  /* 覆盖 Element UI 的问题样式 */
  .el-dialog-container {
    /* 重置导致问题的样式，可以通过开发者工具查看被覆盖前后的差异 */
    position: static !important;
    display: block !important;
    /* 移除隐藏弹窗的样式 */
  }
  
  /* 确保弹窗正常显示 */
  .chat-dialog .el-dialog {
    display: flex !important;
    flex-direction: column;
    margin-top: 5vh !important;
    max-height: 90vh;
  }
  
  /* 可能也需要修复对话框内容区域 */
  .chat-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/ChatPopup/index.vue